import { Label } from "reactstrap";
import { H5, H6, Image, LI, P } from "../../../../AbstractElements";
import { HoverMeetupText1 } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";
import { HoverMeetupData } from "../../../../Data/BonusUi/Timeline";

const HoverMeetup = () => {
  return (
    <LI className="timeline-event">
      <Label className="timeline-event-icon" />
      <div className="timeline-event-wrapper">
        <P className="timeline-thumbnail">{"December 2025 - Meetup"}</P>
        <H5>{HoverMeetupText1}</H5>
        <div className="text-muted">
          {"2209 Leverton Cove RoadSpringfield, MA 01109"}
          <div className="designer-details">
            {HoverMeetupData.map((data) => (
              <div className="designer-profile" key={data.id}>
                <div className="designer-wrap">
                  <Image className="designer-img" src={dynamicImage(`avtar/${data.image}`)} alt="profile" />
                  <div className="designer-content">
                    <H6>{data.name}</H6>
                    <P>{data.number}</P>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </LI>
  );
};
export default HoverMeetup;
